import { IHexGridData } from 'js/bubbleCore/types';
import { colRowToHash } from 'js/bubbleCore/utils/hash';

export function removeFromGrid<T>(grid: IHexGridData<T>, col: number, row: number): void {
  delete grid.values[colRowToHash(col, row)];
}
